import { getLabel } from '../labels';
import { additionalUkTuplesRules } from './setAdditionalUkTuples';

export function restoreTicketDataWithUkCombinations(ticketData, fromCheckbet) {
	try{
		let tuples = null;
		if (!fromCheckbet) {
			tuples = ticketData.tuples;
		}
		else{
			// it is from checkbet: I create an object to be processed by this algoritm
			tuples = [];
			
			for (let kt in ticketData.tuples) {
				const tupleCheckbet = ticketData.tuples[kt];
				const tuple = {
					amount: tupleCheckbet.amount,
					id: tupleCheckbet.npla,
					vMin: tupleCheckbet.minWinnings,
					vMax: tupleCheckbet.maxWinnings,
					combs: tupleCheckbet.combinations
				};
				tuples.push(tuple);
			}
			
		}
		 
		let totalDraws = 0;
		for (let ke in ticketData.events) {
			totalDraws += ticketData.events[ke].bets.length;
		}

		
		const subArraysContainer = {}; // key is the combination amount: to compose an additionalTuple with a set of original tuples, all the combination amounts must be equals
		const tuplesMap = {};
		for (let kt in tuples) {
			const tuple = tuples[kt];
			tuplesMap[tuple.id] = tuple;
			if (!subArraysContainer[tuple.amount]) {
				subArraysContainer[tuple.amount] = [];
			}
			subArraysContainer[tuple.amount].push(tuple.id);
		}
		
		const additionalTuplesMap = {};
		// sort the arrays and get the additionalTuples, if any
		for (let ka in subArraysContainer) {
			subArraysContainer[ka].sort();
			const additionalTuplesMapI = additionalUkTuplesRules.getAdditionalTuplesByIndexesList(subArraysContainer[ka]);
			for (let keyOriginalIndexes in additionalTuplesMapI) {
				additionalTuplesMap[keyOriginalIndexes] = additionalTuplesMapI[keyOriginalIndexes];
			}
		}
	
			// remove the original tuples, and adding the additional ones
		for (let kat in additionalTuplesMap) {
			const keys = kat.split("_");
			const additionalTuple = additionalTuplesMap[kat];
			let amount = 0;
			const combs = additionalTuple.totalCombsExpected;
			let vMin = 0;
			let vMax = 0;
			const id = additionalTuple.index;
			
			
			for (let k in keys) {
				const originalIndex = keys[k];
				amount = tuplesMap[originalIndex].amount;
				vMin += tuplesMap[originalIndex].vMin;
				vMax += tuplesMap[originalIndex].vMax;
				delete tuplesMap[originalIndex];
			}
			tuplesMap[id] = {
				id,
				amount,
				combs,
				vMin,
				vMax,
				isUk: true 
			};
		}
		let finalTuplesArray = [];
		
		for (let id in tuplesMap) {
			const tuple = tuplesMap[id];
			tuple.isAccumulator  = totalDraws == tuple.id;
			finalTuplesArray.push(tuple);
		}
		
		finalTuplesArray.sort((a, b) => {
			if (a.isAccumulator) {
				return -1;
			}
			if (a.id < b.id) {
				return -1;
			}
			if (a.id > b.id) {
				return 1;
			}
			
			return 0;
		});
		if (fromCheckbet) {
			const tups = [];
			// recreate the original dto
			for (let kt in finalTuplesArray) {
				const tuple = finalTuplesArray[kt];
				const tup = {
					amount: tuple.amount,
					npla: tuple.id,
					minWinnings: tuple.vMin,
					maxWinnings: tuple.vMax,
					combinations: tuple.combs,
					isUk: tuple.isUk,
					desc: tuple.id + "-" + getLabel('ticket.system.pla'),
					isAccumulator: tuple.isAccumulator
				};
				tups.push(tup);
			}
			finalTuplesArray = tups;
		}
		ticketData.tuples = finalTuplesArray;
	}
	catch(e) {
		console.error(e);
	}
	
}
